import React, { useEffect } from "react";
import { CodeIcon } from "@heroicons/react/solid";

const Meet = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="container px-5 py-10 mx-auto text-center lg:px-40">
      <div className="flex flex-col w-full mb-20">
        <CodeIcon className="mx-auto inline-block w-10 mb-4" />
        <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
          Hubspot Meetings and Scheduling Integration
        </h1>
        <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
          This{" "}
          <a
            href="https://www.hubspot.com/products/sales/schedule-meeting"
            class="text-pink-600 font-bold"
          >
            HubSpot meeting scheduler
          </a>{" "}
          is a testament to my ability to create customized solutions that meet
          the unique needs of each of my clients. Whether it's building new
          features or optimizing existing ones, I'm always striving to help
          businesses achieve their goals. If you're looking for a Customer
          Success Manager who is both detail-oriented and results-driven, let's
          chat! Feel free to schedule an interview using this <a href="#scheduler">scheduler</a>.
        </p>
      </div>
      <div
        className="meetings-iframe-container"
        data-src="https://meetings.hubspot.com/robert-quinones?embed=true"
      ></div>
    </div>
  );
};

export default Meet;



// WEBPACK FOOTER //
// ./src/components/Meet.js